import {Typography} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledHeader = styled(Typography)(({theme}) => ({
  fontSize: "4rem",
  fontWeight: "bold",
  marginBottom: theme.spacing(2),
}));

export default StyledHeader;
